<div
	class="icon-selector-trigger d-flex align-items-center px-3 gap-2 border border-black rounded-1"
	cdkOverlayOrigin
	#trigger="cdkOverlayOrigin"
	(click)="togglePanel()"
>
	@if (selectedIcon()) {
		<mat-icon>{{ selectedIcon() }}</mat-icon>
	}
	<span class="flex-grow-1">{{ selectedIcon() ? displayIconName(selectedIcon()) : 'Choose an icon' }}</span>
	<mat-icon>{{ panelOpen() ? 'arrow_drop_up' : 'arrow_drop_down' }}</mat-icon>
</div>

<ng-template
	cdkConnectedOverlay
	[cdkConnectedOverlayOrigin]="trigger"
	[cdkConnectedOverlayOpen]="panelOpen()"
	[cdkConnectedOverlayHasBackdrop]="true"
	cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
	(backdropClick)="closePanel()"
	[cdkConnectedOverlayWidth]="320"
>
	<div class="icon-picker-panel d-flex flex-column rounded shadow p-3 bg-white" [style.--icon-size.px]="iconSizePx">
		<mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 mb-2">
			<mat-icon matPrefix>search</mat-icon>
			<input matInput #searchInput placeholder="Search icons..." [formControl]="searchControl" />
		</mat-form-field>

		@if (!allIcons.hasValue()) {
			<p class="text-center m-0 mt-1">Loading icons...</p>
		} @else if (filteredIcons().length === 0) {
			<p class="text-center m-0 mt-1">No icons found</p>
		} @else {
			<cdk-virtual-scroll-viewport [itemSize]="iconSizePx" class="icon-viewport">
				<div *cdkVirtualFor="let row of iconRows()" class="icon-row">
					@for (icon of row; track icon.name) {
						<button
							type="button"
							mat-icon-button
							class="icon-grid-item"
							[class.selected]="icon.name === selectedIcon()"
							(click)="selectIcon(icon.name)"
							[title]="icon.name"
						>
							<mat-icon>{{ icon.name }}</mat-icon>
						</button>
					}
				</div>
			</cdk-virtual-scroll-viewport>
		}
	</div>
</ng-template>
